@for (lenke of lenker(); track lenke.id) {
  <div class="lenke" (click)="navigerTilKilde(lenke)">
    <div class="kilde">
      <span>{{kildefelt(lenke)}}</span><span [innerHTML]="lenke.kildeentitetBeskrivelse | strengMal:'lang'" ></span>
    </div>
    <div class="lenketekst">
      <mat-icon inline="true">link</mat-icon>
      <span>{{ lenke.lenketekst }}</span>
    </div>
  </div>
}
